import { cn } from '../../lib/cn';

export interface SpinnerProps {
  /** Accessible label; pass `null` when a parent already announces loading. */
  label?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const dims = { sm: 'h-4 w-4', md: 'h-6 w-6', lg: 'h-10 w-10' };

export function Spinner({ label = 'Loading', size = 'md', className }: SpinnerProps) {
  const svg = (
    <svg
      className={cn('animate-spin motion-reduce:animate-none', dims[size], className)}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.25" strokeWidth="4" />
      <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
  if (label === null) return svg;
  return (
    <span role="status" className="inline-flex items-center gap-2">
      {svg}
      <span className="sr-only">{label}</span>
    </span>
  );
}

/** Full-area loading state for pages and route transitions. */
export function PageLoader({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="flex min-h-[40vh] w-full items-center justify-center text-primary">
      <Spinner label={label} size="lg" />
    </div>
  );
}
